module.exports = __webpack_public_path__ + "static/media/Portal-Image.3b9e017a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Portal-Image.png
// module id = 106
// module chunks = 0